import { useEffect, useState } from "react";

export type Route =
  | { name: "callback" }
  | { name: "set-password" }
  | { name: "monthly-food" }
  | { name: "app" };

export function matchRoute(pathname: string): Route {
  if (pathname === "/auth/callback") return { name: "callback" };
  if (pathname === "/api/auth/microsoft/callback") return { name: "callback" };
  if (pathname === "/set-password") return { name: "set-password" };
  if (pathname === "/ushqimi-mujor") return { name: "monthly-food" };
  return { name: "app" };
}

const ROUTE_CHANGE_EVENT = "edubgt:routechange";

export function navigate(path: string) {
  if (path === window.location.pathname + window.location.search) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new Event(ROUTE_CHANGE_EVENT));
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => matchRoute(window.location.pathname));

  useEffect(() => {
    const update = () => setRoute(matchRoute(window.location.pathname));
    window.addEventListener("popstate", update);
    window.addEventListener(ROUTE_CHANGE_EVENT, update);
    return () => {
      window.removeEventListener("popstate", update);
      window.removeEventListener(ROUTE_CHANGE_EVENT, update);
    };
  }, []);

  return route;
}
